import { render, staticRenderFns } from "./ExclamationMark.vue?vue&type=template&id=1ae57365&"
import script from "./ExclamationMark.vue?vue&type=script&lang=js&"
export * from "./ExclamationMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae57365')) {
      api.createRecord('1ae57365', component.options)
    } else {
      api.reload('1ae57365', component.options)
    }
    module.hot.accept("./ExclamationMark.vue?vue&type=template&id=1ae57365&", function () {
      api.rerender('1ae57365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ExclamationMark.vue"
export default component.exports